// 需求分析 Seo
export default class GA {
  constructor(survey, page, moduleName) {
    this.survey = survey
    this.page = page
    this.moduleName = moduleName
  }
  
  setForGA() {
    switch (this.moduleName) {
      case 'buyHouse':
        this.setBuyHouseGA()
        break
      case 'educationFund':
        this.setEducationFundGA()
        break
    }
  }
  
  setBuyHouseGA() {
    let title = this.survey.label.replace('？', '')
    title.replace('！', '')
    this.title = '買房試算－' + title + ' | 買保險 SmartBeb'
    this.pushEvent()
  }
  
  setEducationFundGA() {
    let title = this.survey.label.replace('？', '')
    title.replace('！', '')
    this.title = '子女教育金試算－' + title + ' | 買保險 SmartBeb'
    this.pushEvent()
  }
  
  pushEvent() {
    if (this.page.page_no !== 0) {
      document.title = this.title
      history.replaceState(null, '', (location.pathname + location.search + location.hash))
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Pageview',
        'pagePath': (location.pathname).substr(1) + '/quiz/' + (this.survey.type !== 'form' ? this.page.page_no : 'form'),
        'pageTitle': this.title,
      });
    }
  }
  
  static pushRetireEvent(questionNo, title) {
    document.title = '退休試算－' + title + ' | 買保險 SmartBeb'
    history.replaceState(null, '', (location.pathname + location.search + location.hash))
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Pageview',
      'pagePath': (location.pathname).substr(1) + '/quiz/' + questionNo,
      'pageTitle': '退休試算－' + title + ' | 買保險 SmartBeb',
    });
  }
}